import { DownloadOutlined } from '@ant-design/icons';
import { AgGridReact } from 'ag-grid-react';
import { Button, Spin } from 'antd';
import React, { useRef } from 'react';
import './Customers.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { IDataDefaulFilter } from './ReportCustomer';
import { ColDef } from "ag-grid-community";
import { getWidthFromHeaderV2 } from '../../until';
import { NodataTable } from '../../components/NoDataTable';

interface BrandReportRow {
  brandId: number;
  name: string;
  own1: number;
  own2: number;
  own3: number;
  own4: number;
  own5: number;
  own6_10: number;
  own10plus: number;
  total: number;
}

// ─── AG Grid column defs ──────────────────────────────────────────────────────

const CustomerGroupCellRenderer = (params: any) => (
  <div className='custom-page-css w-full flex items-center justify-between'>
    {params.value}&nbsp;
    <a href="#" style={{ color: '#1890ff' }} onClick={(e) => e.preventDefault()}>
      Xem DS
    </a>
  </div >
);
// name: item.brandName,

//       own1: item["1car"] ?? 0,
//       own2: item["2car"] ?? 0,
//       own3: item["3car"] ?? 0,
//       own4: item["4car"] ?? 0,
//       own5: item["5car"] ?? 0,
//       own6_10: item["6_10car"] ?? 0,
//       own10plus: item.greaterThan10Car ?? 0,

//       total: item.total ?? 0,


// ─── Component ────────────────────────────────────────────────────────────────

interface props {
  data: any[]
  dataFilter: IDataDefaulFilter
  showLoading: boolean
  handleExport: () => void
}

const ReportMarketingCampaign: React.FC<props> = ({
  data,
  dataFilter,
  showLoading,
  handleExport
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const { unitTemp } = useSelector(selectorInfoUser)
  const navigate = useNavigate()



  const linkCellSpan = (params: any) => (
    <span
      style={{
        color: '#1890ff',
        cursor: 'pointer',
        pointerEvents: 'none',
      }}
    >
      {params.value}
    </span>
  );


  const handleLink = (params: any, type: number) => {

    return (
      navigate('/analysis-report/customers-detail', {
        state: {
          firstLink: '/analysis-report/customers',
          brandId: params.data?.brandId,
          dataFilter: dataFilter,
          unitIdDefault: unitTemp,
          type: type,
          brandName: params.data?.name
        }
      })
    )
  };


  const columnDefs: ColDef<BrandReportRow>[] = [
    {
      headerName: 'Thương hiệu',
      field: 'name',
      sortable: true,

      minWidth: getWidthFromHeaderV2("Thương hiệu"),
    },
    {
      headerName: 'Sở hữu 1 xe',
      field: 'own1',
      minWidth: getWidthFromHeaderV2("Sở hữu 1 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 1),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu 2 xe',
      field: 'own2',
      minWidth: getWidthFromHeaderV2("Sở hữu 2 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 2),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu 3 xe',
      field: 'own3',
      minWidth: getWidthFromHeaderV2("Sở hữu 3 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 3),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu 4 xe',
      field: 'own4',
      minWidth: getWidthFromHeaderV2("Sở hữu 4 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 4),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu 5 xe',
      field: 'own5',
      minWidth: getWidthFromHeaderV2("Sở hữu 5 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 5),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu 6 - 10 xe',
      field: 'own6_10',
      minWidth: getWidthFromHeaderV2("Sở hữu 6 - 10 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 6),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Sở hữu > 10 xe',
      field: 'own10plus',
      minWidth: getWidthFromHeaderV2("Sở hữu > 10 xe"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 7),
      cellRenderer: linkCellSpan,
    },
    {
      headerName: 'Tổng số khách hàng',
      field: 'total',
      sortable: true,
      minWidth: getWidthFromHeaderV2("Tổng số khách hàng"),
      comparator: (valueA, valueB) => {
        const a = Number(String(valueA).replace(/,/g, ''));
        const b = Number(String(valueB).replace(/,/g, ''));
        return a - b;
      },
      cellStyle: { cursor: 'pointer' },
      onCellClicked: (params: any) => handleLink(params, 8),
      cellRenderer: linkCellSpan,
    },
  ];

  const defaultColDef = {
    resizable: true,
    flex: 1,
  };
  return (
    <>

      {/* ── Table section ── */}
      <div
        style={{ width: '100%' }}
        className="custom-page-css flex flex-col flex-1 border rounded-2 gap-2 p-6"
      >
        <div className="custom-page-css flex justify-between items-center mb-2">
          <h3 className="custom-page-css text-344054 text-base font-medium">Bảng thống kê chi tiết số lượng và tỷ lệ khách hàng theo số xe sở hữu</h3>
          <Button
            className="custom-pape-css text-sm text-344054 font-regular px-3 py-1 border rounded"
            onClick={handleExport}
          >
            <DownloadOutlined />
            Xuất báo cáo
          </Button>
        </div>

        {
          showLoading ? (
            <div className="report-ag-table">
              <div className="ag-theme-alpine" style={{ width: '100%' }}>
                <AgGridReact
                  ref={gridRef}
                  rowData={data}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  domLayout="autoHeight"
                  rowHeight={48}
                  getRowStyle={(params: any) => ({
                    backgroundColor: params.node.rowIndex % 2 === 0 ? '#ffffff' : '#F8F8F8',
                  })}
                  suppressMovableColumns
                  suppressCellFocus
                  overlayNoRowsTemplate={NodataTable}
                />
              </div>
            </div>
          ) : (
            <div
              className='custom-page-css flex flex-col gap-2 items-center justify-center'
              style={{ width: '100%', height: '100%' }}
            >
              <Spin size="default" />
              <span>Đang tải...</span>
            </div>
          )
        }

      </div>
    </>
  );
};

export default ReportMarketingCampaign;
